export const QUIZZES = {
  'living-room': [
    {
      question: `Appliances like TVs, games stations, soundbars, and computers can use
      power even when they are turned off. Which device can prevent appliances
      from using unnecessary energy when they are not in use?`,
      answer: ['a'],
      options: {
        a: 'Advanced Powerstrip',
        b: 'Blender',
        c: 'LED',
        d: 'Lava Lamp',
      },
    },
    {
      question: `If you have a central AC, you can get a $75 rebate from Hawaii
      Energy to maintain it annually with a tune-up.`,
      answer: ['a'],
      options: {
        a: 'True',
        b: 'False',
      },
    },
  ],
  kitchen: [
    {
      question: `How many degrees does the oven temperature drop evertime you open it to
      take a peek at those cookies?`,
      answer: ['b'],
      options: {
        a: '100° F',
        b: '25° F',
        c: '2° F',
        d: '250° F',
      },
    },
    {
      question: `What is the ideal temperature for the fresh food compartment of
      your refrigerator?`,
      answer: ['b'],
      options: {
        a: '0° F',
        b: '36-42° F',
        c: '110-120° F',
        d: '80° F',
      },
    },
    {
      question: `Select all options that will help you save energy and water
      when washing dishes:`,
      answer: ['a', 'c'],
      options: {
        a: 'Run the dishwasher with full loads',
        b: 'Use chilled bottled water to wash dishes',
        c: 'Choose ENERGY STAR® certified washers',
        d: 'Wash the dishes in the sink before putting them in the dishwasher',
      },
    },
  ],
  bedroom: [
    {
      question: `When looking up at the ceiling fan, which direction should the
      fan be turning for the best natural cooling?`,
      answer: ['b'],
      options: {
        a: 'Clockwise',
        b: 'Counter-clockwise',
        c: 'Both',
      },
    },
    {
      question: `How much less energy do LED light bulbs use compared to old
        incandescant bulbs?`,
      answer: ['c'],
      options: {
        a: '10%',
        b: "LEDs don't use energy",
        c: '90%',
        d: 'LEDs use more energy',
      },
    },
    {
      question:
        'How much longer do LED light bulbs last compared to old incandescant bulbs?',
      answer: ['d'],
      options: {
        a: "They don't last as long",
        b: '1x',
        c: '200x',
        d: '25x',
      },
    },
  ],
  bathroom: [
    {
      question: `A faucet leaking one drop per second can waste how many gallons
      of water in a year?`,
      answer: ['d'],
      options: {
        a: '1 gallon',
        b: '20 gallons',
        c: '90,000 gallons',
        d: '1,000 gallons',
      },
    },
    {
      question:
        'Every minute trimmed from a shower can save up to how much water?',
      answer: ['b'],
      options: {
        a: '2 pints',
        b: '3-6 gallons',
        c: '25-30 gallons',
        d: '5-7 tablespoons',
      },
    },
    {
      question: 'What is the ideal temperature to set your water heater at?',
      answer: ['a'],
      options: {
        a: '120° F',
        b: '250° F',
        c: '2° F',
        d: '32° F',
      },
    },
  ],
  'laundry-room': [
    {
      question: `How much less energy do ENERGY STAR® certified dryers use compared
        to non ENERGY STAR® models?`,
      answer: ['a'],
      options: {
        a: '25%',
        b: '100%',
        c: '50%',
        d: '0%',
      },
    },
    {
      question: 'Select all the ways you can save energy while doing laundry:',
      answer: ['a', 'c'],
      options: {
        a: 'Wash on cold',
        b: "Powerwash clothes to make sure they're clean",
        c: "Use a clothesline to take advantage of Hawaii's natural tradewinds and sunshine to dry your clothes",
        d: 'Use a diswasher to do your laundry',
      },
    },
  ],
  garage: [
    {
      question: `How much money can getting rid of your second refrigerator save
      your family every year?`,
      answer: ['b'],
      options: {
        a: '$1',
        b: '$200',
        c: '$123',
        d: '$2,000',
      },
    },
    {
      question: 'How often should you tune up your solar water heater?',
      answer: ['c'],
      options: {
        a: 'Every 2 weeks',
        b: "Solar water heaters don't need tune ups",
        c: 'Every 5 years',
        d: 'Every 15 years',
      },
    },
    {
      question:
        'Hawaii Energy will pick up your old refrigerator to recycle, and also give you a $___ rebate for getting rid of that old clunker.',
      answer: ['a'],
      options: {
        a: '$75',
        b: '$1',
        c: '$10',
        d: '$33',
      },
    },
  ],
  city: [
    {
      question:
        "What percentage of Hawaii's greenhouse gas emissions come from buildings?",
      answer: ['d'],
      options: {
        a: '10%',
        b: '1%',
        c: '99%',
        d: '35%',
      },
    },
    {
      question: 'What time is "peak demand" in Hawaii?',
      answer: ['b'],
      options: {
        a: '10pm-9am',
        b: '5pm-10pm',
        c: '12am-1am',
        d: 'Noon',
      },
    },
    {
      question: 'Select two ways you can help spread out the energy load:',
      answer: ['a', 'b'],
      options: {
        a: 'Charge your electric vehicle during non-peak hours',
        b: 'Set the timer on your water heater to turn on during non-peak hours',
        c: 'Turn off all lights in your house before midnight',
        d: 'Water your lawn at noon',
      },
    },
  ],
}



// WEBPACK FOOTER //
// ./src/quizzes.js